import type { StoryProvider } from '~/types/story'

/**
 * Provides global access to the top level story object for the currently loaded page
 */
export const useStoryProviderStore = defineStore('story-provider', () => {
  const story: Ref<StoryProvider['story'] | undefined> = ref()

  const setPageStory = (newStory: StoryProvider['story']) => {
    story.value = newStory
  }

  function $reset() {
    story.value = undefined
  }

  const computedStory = computed(() => story.value?.value)

  return {
    story: computedStory,
    setPageStory,
    $reset,
  }
})
